import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export function useLiveEnabled() {
  const [isEnabled, setIsEnabled] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchSetting = async () => {
      try {
        const { data, error } = await supabase
          .from('site_settings')
          .select('value')
          .eq('key', 'live_match_enabled')
          .maybeSingle();

        if (error) throw error;
        setIsEnabled(data?.value === true);
      } catch (error) {
        console.error('Error fetching live_match_enabled setting:', error);
        setIsEnabled(false);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSetting();

    // Subscribe to changes
    const channel = supabase
      .channel('live_enabled_changes')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'site_settings',
          filter: 'key=eq.live_match_enabled',
        },
        (payload) => {
          if (payload.new && typeof payload.new === 'object' && 'value' in payload.new) {
            setIsEnabled(payload.new.value === true);
          }
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  return { isEnabled, isLoading };
}
